<div *ngIf="appService.isLoading" style="display: flex; justify-content: center;padding-top: 15%;">
    <mat-spinner diameter="50" strokeWidth="4"></mat-spinner>
</div>
<div *ngIf="!appService.isLoading">
    <div *ngIf="appService.islogin">

        <div class="header">
            <!-- <button mat-button (click)="sidenav.toggle()" class="mobile_btn float-left" style="color: #6c757d"><mat-icon>menu</mat-icon></button> -->
            <button mat-button (click)="toggleSidebar()" class="mobile_btn float-left toggle_btn">
                <mat-icon>menu</mat-icon>
            </button>
            <app-top-menu></app-top-menu>
        </div>
        <!-- <mat-sidenav-container>

            <mat-sidenav style="margin-top: 40px;" #sidenav class="sidenav" [ngClass]="{'open': isSidebarOpen}" fixedInViewport="true" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async)">
                <app-sidenav-menu *ngIf="sidenavMenuItems?.length > 0" [menuItems]="sidenavMenuItems" [menuParentId]="0"></app-sidenav-menu>
            </mat-sidenav>
        </mat-sidenav-container> -->
        <mat-sidenav-container>
            <mat-sidenav style="margin-top: 40px;" #sidenav class="sidenav" [ngClass]="{'open': isSidebarOpen}"
                fixedInViewport="true" [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
                [mode]="(isHandset$ | async) ? 'over' : 'side'" [opened]="!(isHandset$ | async)">
                <app-sidenav-menu *ngIf="sidenavMenuItems?.length > 0" [menuItems]="sidenavMenuItems"
                    [menuParentId]="0"></app-sidenav-menu>
            </mat-sidenav>
        </mat-sidenav-container>
        <!--  -->

        <div class="page-wrapper">
            <div class="cnr_pd_20_10">
                <router-outlet></router-outlet>
            </div>
        </div>
        <div *ngIf="showBackToTop" fxLayout="row" fxLayoutAlign="center center" class="back-to-top transition"
            (click)="scrollToTop()">
            <mat-icon>arrow_upward</mat-icon>
        </div>

    </div>
    <div class="main-wrapper account-wrapper" *ngIf="!appService.islogin" style="margin-top: 15vh;">
        <div class="account-page">
            <div class="account-center">
                <div class="account-box">
                    <div class="row m-b-20">
                        <div class="col-md-12">
                            <h3 class="text-center txt-primary">Login</h3>
                        </div>
                    </div>

                    <form class="form-signin">
                        <div class="form-group"
                            [class.has-error]="user_NameControl.invalid && user_NameControl.touched">
                            <label>Email</label>
                            <input type="text" autocomplete="off" class="form-control " required email name="user_name"
                                id="user_name" [(ngModel)]="user_name" #user_NameControl="ngModel"
                                placeholder=" Enter Email">
                            <span style="color:red;margin-left:15px" class="help-block"
                                *ngIf="user_NameControl.errors?.required && user_NameControl.touched">
                                Please Enter Email!</span>
                            <span style="color:red;margin-left:15px" class="help-block"
                                *ngIf="user_NameControl.errors?.email && user_NameControl.touched">
                                Enter Valid Email!</span>
                        </div>

                        <div class="form-group" [class.has-error]="passwordControl.invalid && passwordControl.touched">
                            <label>Password</label>
                            <span style="display: flex;">
                                <input type="{{showPassword?'text':'password'}}" class="form-control "
                                    autocomplete="nope" required name="password" id="password" [(ngModel)]="password"
                                    #passwordControl="ngModel" placeholder=" Enter Password">
                                <mat-icon *ngIf="showPassword" class="show_eye_icon"
                                    (click)="onPasswordToggle()">visibility</mat-icon>
                                <mat-icon *ngIf="!showPassword" class="show_eye_icon"
                                    (click)="onPasswordToggle()">visibility_off</mat-icon>
                            </span>
                            <span style="color:red;margin-left:15px" class="help-block"
                                *ngIf="passwordControl.invalid && passwordControl.touched">Please Enter Password!</span>
                        </div>

                        <div class="form-group text-right">
                            <label (click)="openDialog()" style="cursor: pointer;">Forgot your password?</label>
                        </div>
                        <div class="form-group text-center">
                            <button type="button" class="btn btn-primary account-btn"
                                (click)="getLogin()">Login</button>


                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>